import {CompanyViewModel} from "@modules/onBoarding/presentation/viewModel/CompanyViewModel";

export class CompaniesViewModel {
    private readonly _selectTitle: string;
    private readonly _companies: CompanyViewModel[];
    private readonly _notListedButtonLabel: string;
    private readonly _confirmSelectionButtonLabel: string;

    constructor(selectTitle: string, companies: CompanyViewModel[], notListedButtonLabel: string, confirmSelectionButtonLabel: string) {
        this._selectTitle = selectTitle;
        this._companies = companies;
        this._notListedButtonLabel = notListedButtonLabel;
        this._confirmSelectionButtonLabel = confirmSelectionButtonLabel;
    }

    get selectTitle(): string {
        return this._selectTitle;
    }

    get companies(): CompanyViewModel[] {
        return this._companies;
    }

    get notListedButtonLabel(): string {
        return this._notListedButtonLabel;
    }

    get confirmSelectionButtonLabel(): string {
        return this._confirmSelectionButtonLabel;
    }

}
